<div class="sign-agreement-page">
  <!-- Loading State -->
  <div v-if="spinner" :class="$style.pageMargin">
    <animation-processing fill="new-blue" :class="$style.pageSpinner"></animation-processing>
    <span v-if="!showSpinnerText" class="mt-serif mt-serif--size3">
      {{$t('pages.contract.spinner.signed_agreement')}}
    </span>
    <span v-else class="mt-serif mt-serif--size3">
      {{$t('pages.contract.spinner.creating_agreement')}}
    </span>
  </div>

  <!-- Form Content -->
  <div v-else>
    <VeeForm v-slot="{ errors, handleSubmit, validateField }">

      <!-- Title Bar -->
      <div class="sign-agreement-page__title-bar" data-qa-id="sign-agreement-page-title">
        <MdTypography tag="h1" variant="heading6--medium" color="spirits--900">
          {{$t('pages.contract.sign_contract.mfda')}}
        </MdTypography>
      </div>

      <!-- Description -->
      <div class="sign-agreement-page__description">
        <MdTypography tag="p" variant="body1--regular" color="spirits--700">
          {{$t('pages.contract.sign_contract.mfda_desc_1')}}
        </MdTypography>
        <MdTypography tag="p" variant="body1--regular" color="spirits--700">
          <span v-html="$t('pages.contract.sign_contract.mfda_desc_2')"></span>
        </MdTypography>
      </div>

      <!-- Form -->
      <div class="sign-agreement-page__form">
        <div class="sign-agreement-page__sections">

          <!-- Foundry Section -->
          <div class="sign-agreement-page__section">
            <MdTypography tag="h2" variant="heading7--medium" color="black">
              {{$t('pages.contract.sign_contract.section_foundry')}}
            </MdTypography>
            <div class="sign-agreement-page__grid">
              <!-- Foundry name (disabled) -->
              <div class="sign-agreement-page__field sign-agreement-page__field--filled sign-agreement-page__field--disabled">
                <span class="sign-agreement-page__field-label">{{$t('pages.contract.sign_contract.foundry_name')}}</span>
                <input :id="$vId(this, 'fou-name')" type="text" name="foundry name" :value="contractData.foundry.name" disabled class="sign-agreement-page__field-value" />
              </div>
              <!-- Foundry owner name -->
              <div class="sign-agreement-page__field" :class="{'sign-agreement-page__field--filled': contractForm.foundryOwnerName, 'sign-agreement-page__field--error': Object.hasOwn(errors, 'foundry owner name')}">
                <span v-if="contractForm.foundryOwnerName" class="sign-agreement-page__field-label">{{$t('pages.contract.sign_contract.owner_name')}}</span>
                <TextField name="foundry owner name" rules="required|script_tag_validate" v-model="contractForm.foundryOwnerName" :data-test-id="$vId(this, 'fou-owner-name')" :placeholder="$t('pages.contract.sign_contract.owner_name')" :input-class="['sign-agreement-page__field-value']" :error-class="['sign-agreement-page__field-error-msg']" :moduleName="this.$route.name" :foundryId="this.getfIdFromRoute()" :description="contractForm.foundryOwnerName" @update-banned-word="updateBannedWords" @blur="onContractNameBlur($event, 'foundryOwnerName')" />
              </div>
            </div>
          </div>

          <!-- Contract Signer Section -->
          <div class="sign-agreement-page__section">
            <MdTypography tag="h2" variant="heading7--medium" color="black">
              {{$t('pages.contract.sign_contract.section_contract_signer')}}
            </MdTypography>
            <div class="sign-agreement-page__grid">
              <div class="sign-agreement-page__field" :class="{'sign-agreement-page__field--filled': contractForm.signerName, 'sign-agreement-page__field--error': Object.hasOwn(errors, 'contract signer name')}">
                <span v-if="contractForm.signerName" class="sign-agreement-page__field-label">{{$t('pages.contract.sign_contract.signer_name')}}</span>
                <TextField name="contract signer name" rules="required|script_tag_validate" v-model="contractForm.signerName" :data-test-id="$vId(this, 'fou-signer-name')" :placeholder="$t('pages.contract.sign_contract.signer_name')" :input-class="['sign-agreement-page__field-value']" :error-class="['sign-agreement-page__field-error-msg']" @blur="onContractNameBlur($event, 'signerName')" />
              </div>
              <div class="sign-agreement-page__field" :class="{'sign-agreement-page__field--filled': contractForm.email, 'sign-agreement-page__field--error': Object.hasOwn(errors, 'email')}">
                <span v-if="contractForm.email" class="sign-agreement-page__field-label">{{$t('pages.contract.sign_contract.address.email')}}</span>
                <TextField name="email" type="email" rules="required|email|script_tag_validate" v-model="contractForm.email" :id="$vId(this, 'email')" :placeholder="$t('pages.contract.sign_contract.address.email')" :input-class="['sign-agreement-page__field-value']" :error-class="['sign-agreement-page__field-error-msg']" />
              </div>
              <div class="sign-agreement-page__field" :class="{'sign-agreement-page__field--filled': contractForm.signerTitle, 'sign-agreement-page__field--error': Object.hasOwn(errors, 'title')}">
                <span v-if="contractForm.signerTitle" class="sign-agreement-page__field-label">{{$t('pages.contract.sign_contract.title')}}</span>
                <TextField name="title" rules="required|script_tag_validate" v-model="contractForm.signerTitle" :data-test-id="$vId(this, 'fou-signer-title')" :placeholder="$t('pages.contract.sign_contract.title')" :input-class="['sign-agreement-page__field-value']" :error-class="['sign-agreement-page__field-error-msg']" />
              </div>
            </div>
          </div>

          <!-- Address Section -->
          <div class="sign-agreement-page__section">
            <MdTypography tag="h2" variant="heading7--medium" color="black">
              {{$t('pages.contract.sign_contract.address.title')}}
            </MdTypography>
            <div class="sign-agreement-page__grid">
              <div class="sign-agreement-page__field" :class="{'sign-agreement-page__field--filled': contractForm.address1, 'sign-agreement-page__field--error': Object.hasOwn(errors, 'address 1')}">
                <span v-if="contractForm.address1" class="sign-agreement-page__field-label">{{$t('pages.contract.sign_contract.address.add1')}}</span>
                <TextField name="address 1" rules="required|script_tag_validate" v-model="contractForm.address1" :id="$vId(this, 'address-1')" :placeholder="$t('pages.contract.sign_contract.address.add1')" :input-class="['sign-agreement-page__field-value']" :error-class="['sign-agreement-page__field-error-msg']" />
              </div>
              <div class="sign-agreement-page__field" :class="{'sign-agreement-page__field--filled': contractForm.address2, 'sign-agreement-page__field--error': Object.hasOwn(errors, 'address 2')}">
                <span v-if="contractForm.address2" class="sign-agreement-page__field-label">{{$t('pages.contract.sign_contract.address.add2')}}</span>
                <span class="sign-agreement-page__field-optional">{{$t('pages.contract.sign_contract.email_communication.optional')}}</span>
                <TextField name="address 2" rules="script_tag_validate" v-model="contractForm.address2" :id="$vId(this, 'address-2')" :placeholder="$t('pages.contract.sign_contract.address.add2')" :input-class="['sign-agreement-page__field-value']" :error-class="['sign-agreement-page__field-error-msg']" />
              </div>
              <div class="sign-agreement-page__field" :class="{'sign-agreement-page__field--filled': contractForm.city, 'sign-agreement-page__field--error': Object.hasOwn(errors, 'city')}">
                <span v-if="contractForm.city" class="sign-agreement-page__field-label">{{$t('pages.contract.sign_contract.address.city')}}</span>
                <TextField name="city" rules="required|script_tag_validate" v-model="contractForm.city" :id="$vId(this, 'city')" :placeholder="$t('pages.contract.sign_contract.address.city')" :input-class="['sign-agreement-page__field-value']" :error-class="['sign-agreement-page__field-error-msg']" />
              </div>
              <!-- Country dropdown -->
              <div class="sign-agreement-page__field sign-agreement-page__field--dropdown" :class="{'sign-agreement-page__field--filled': backendCountryValue, 'sign-agreement-page__field--error': Object.hasOwn(errors, 'country')}" @focusout="validateField('country')">
                <span v-if="backendCountryValue" class="sign-agreement-page__field-label">{{$t('pages.contract.sign_contract.address.country')}}</span>
                <VeeField v-model="backendCountryValue" name="country" rules="required" type="hidden" />
                <FouDropdown
                  :options="country.options"
                  :default-value="backendCountryValue"
                  :placeholder="$t('pages.contract.sign_contract.address.country')"
                  :selectAction="updateCountryValue"
                  :customClass="'sign-agreement-page__dropdown'"
                  :customActiveClass="'sign-agreement-page__dropdown--active'"
                  name="country-select"
                  :showErrorState="false"
                  data-qa-id="sign-agreement-country"
                />
                <span v-if="Object.hasOwn(errors, 'country')" class="sign-agreement-page__field-error-msg">{{ errors['country'] }}</span>
              </div>
              <div class="sign-agreement-page__field" :class="{'sign-agreement-page__field--filled': contractForm.zipCode, 'sign-agreement-page__field--error': Object.hasOwn(errors, 'zip / postal code')}">
                <span v-if="contractForm.zipCode" class="sign-agreement-page__field-label">{{$t('pages.contract.sign_contract.address.postal_code')}}</span>
                <TextField name="zip / postal code" :rules="`required|max:10|postal_code_rule:${backendCountryValue}`" v-model.trim="contractForm.zipCode" @update-detect="(e)=> contractForm.zipCode = contractForm.zipCode.toUpperCase()" :id="$vId(this, 'zip / postal code')" :placeholder="$t('pages.contract.sign_contract.address.postal_code')" :input-class="['sign-agreement-page__field-value']" :error-class="['sign-agreement-page__field-error-msg']" />
              </div>
              <div class="sign-agreement-page__field" :class="{'sign-agreement-page__field--filled': contractForm.phone, 'sign-agreement-page__field--error': Object.hasOwn(errors, 'telephone')}">
                <span v-if="contractForm.phone" class="sign-agreement-page__field-label">{{$t('pages.contract.sign_contract.address.telephone')}}</span>
                <TextField name="telephone" rules="required|telephone" v-model="contractForm.phone" :id="$vId(this, 'telephone')" :placeholder="$t('pages.contract.sign_contract.address.telephone')" :input-class="['sign-agreement-page__field-value']" :error-class="['sign-agreement-page__field-error-msg']" />
              </div>
              <!-- State dropdown (conditional) -->
              <div v-if="showStates" class="sign-agreement-page__field sign-agreement-page__field--dropdown" :class="{'sign-agreement-page__field--filled': backendStateValue, 'sign-agreement-page__field--error': Object.hasOwn(errors, 'state')}" @focusout="validateField('state')">
                <span v-if="backendStateValue" class="sign-agreement-page__field-label">{{$t('pages.contract.sign_contract.address.state_region')}}</span>
                <VeeField v-model="backendStateValue" name="state" rules="required" type="hidden" />
                <FouDropdown
                  :options="states.options"
                  :default-value="backendStateValue"
                  :placeholder="$t('pages.contract.sign_contract.address.state_region')"
                  :selectAction="updateStateValue"
                  :customClass="'sign-agreement-page__dropdown'"
                  :customActiveClass="'sign-agreement-page__dropdown--active'"
                  name="state-select"
                  :showErrorState="false"
                  data-qa-id="sign-agreement-state"
                />
                <span v-if="Object.hasOwn(errors, 'state')" class="sign-agreement-page__field-error-msg">{{ errors['state'] }}</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Email Communication Section -->
      <div class="sign-agreement-page__email-section">
        <div class="sign-agreement-page__email-content">
          <MdTypography tag="h2" variant="heading7--medium" color="black">
            {{$t('pages.contract.sign_contract.email_communication.text')}}
          </MdTypography>
          <MdTypography tag="p" variant="body1--regular" color="spirits--700">
            {{$t('pages.contract.sign_contract.email_communication.desc')}}
          </MdTypography>
        </div>
        <MdCheckbox
          name="emailConsent"
          value="Yes"
          :checked="contractForm.emailConsent === 'Yes'"
          accessibilityLabel="Email marketing consent"
          label
          data-qa-id="sign-agreement-email-consent"
          @mdChange="contractForm.emailConsent = $event.detail ? 'Yes' : ''"
        >
          {{$t('pages.contract.sign_contract.email_communication.sort_desc')}}
        </MdCheckbox>
      </div>

      <!-- Submit Section -->
      <div class="sign-agreement-page__submit-section">
        <MdButton
          size="medium"
          variant="none"
          color="blue"
          type="button"
          data-qa-id="sign-agreement-submit-btn"
          @handleclick="handleSubmit($event, acceptAgreement)"
        >
          <MdIconAgreements slot="icon-start" size="16px" color="white" />
          {{$t('pages.contract.sign_contract.accept_agreement.button')}}
        </MdButton>
        <MdTypography tag="p" variant="body1--regular" color="spirits--700">
          {{$t('pages.contract.sign_contract.accept_agreement.warning')}}
        </MdTypography>
      </div>

    </VeeForm>
  </div>

  <!-- Error Toast -->
  <div v-if="errorDSFlag" :class="$style.errorDS">
    <hr :class="$style.errorBorder" />
    <span :class="$style.error_icon"></span>
    <p :class="$style.errorMessage" v-html="$t('pages.contract.error_message')"></p>
  </div>
</div>
